import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.0_@types+node@24.0.1_db0@0.3.2_eslint@9.19.0_jiti@2.4.2_f8b07c7c96ac305f77daa7e291ebaa08/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}